import React from 'react';

import { Heading, PropertyGroup } from '../../../../components';

import css from '../../../../containers/ListingPage/ListingPage.module.css';

const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

const ProducersPlacesWithIcons = ({ listing, listingConfig }) => {
  const producersPlacesSelectedValues = listing.attributes.publicData.producers_places;
  const fieldConfig = listingConfig.listingFields.find(c => c.key === 'producers_places');

  if (!producersPlacesSelectedValues || !fieldConfig) return null;

  const { enumOptions, showConfig } = fieldConfig;

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {showConfig.label}
      </Heading>
      <PropertyGroup
        id="producers_places"
        options={createFilterOptions(enumOptions)}
        selectedOptions={producersPlacesSelectedValues}
        twoColumns={enumOptions.length > 5}
      />
    </div>
  );
};

export default ProducersPlacesWithIcons;
